import Button from '../ui/Button';

function AccessDisabledScreen({ title = 'Acceso no habilitado', message, onRetry, onSignOut }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Family Growers</h1>
          <p className="mt-1 text-sm text-gray-500">App de Campo</p>
        </div>

        <div className="w-full rounded-2xl border border-amber-200 bg-amber-50 p-6">
          <p className="font-medium text-amber-800">{title}</p>
          <p className="mt-2 text-sm text-amber-700">{message}</p>
        </div>

        <div className="flex w-full max-w-xs flex-col gap-3">
          {onRetry && (
            <Button variant="secondary" onClick={onRetry}>
              Reintentar
            </Button>
          )}
          <Button variant="primary" onClick={onSignOut}>
            Cerrar sesión
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AccessDisabledScreen;
